export default __webpack_public_path__ + "static/media/UniversLTStd.84678313.woff";